<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20 blog-single-post">
      <loading v-if="loading" class="mt20" :text="'Please wait'|translate"></loading>

      <p class="mt20 alert alert-info" v-if="!post && !loading">{{'There is post'|translate}}</p>
      <div v-if="post">
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'Home', params: {}}">{{'Home'|translate}}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'AllPosts', params: {  }}">{{'All posts'|translate}}</router-link>
          </li>

          <li class="active">{{post.title}}</li>
        </ol>
        <div class="row">
          <div class="col-md-9">
            <h3 class="title">{{post.title}}</h3>
            <p>
              <span class="cat">
                <i class="fas fa-tag"></i>

                <router-link
                  :to="{ name: 'BlogCatPosts', params: { cat_id: post.category_id,cat_slug:post.category_slug }}"
                >{{post.category_name}}</router-link>
              </span>
              &nbsp;&nbsp;
              <span>
                <i class="fas fa-user"></i>
                <router-link
                  :to="{ name: 'BlogUserPosts', params: { user_id: post.user_id,user_slug:post.author_slug }}"
                >{{post.author_name}}</router-link>
              </span>
            </p>
            <div class="description mt20" v-html="post.content"></div>
          </div>
          <div class="col-md-3">
            <div class="panel panel-info">
              <div class="panel-heading">{{'Categories'|translate}}</div>
              <div class="panel-body">
                <ul>
                  <li class="mt5" v-for="(item) in categories" :key="item.id">
                    <router-link
                      :to="{ name: 'BlogCatPosts', params: { cat_id: item.id,cat_slug:item.slug }}"
                    >{{item.name}} ({{item.count_posts}})</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
// import Paginate from "vuejs-paginate";
// import FormStore from '@/components/forms/FormStore'

import Loading from "@/components/elements/Loading";
export default {
  name: "Home",
  components: {
    MyHeader,
    Loading
  },
  data() {
    return {
      loading: true,
      categories: [],
      post: null,
      send_params: {
        offset: 0,
        limit: -1,
        id: ""
      }
    };
  },

  methods: {
    getPost() {
      this.loading = true;
      Utils.request(this, true, "blog")
        .get(`/blogs/?${Utils.arrayToRequestParam(this.send_params)}`)
        .then(response => {
          this.loading = false;
          let data = response.data;
          if (data.status === "ok") {
            let list = data.data.list.map(item => {
              let temp = new Date(parseInt(item.add_time) * 1000);
              item.add_date = this.$moment(temp);
              return item;
            });
            if (list.length == 1) {
              this.post = list[0];
            }

            // console.log("this.total_page", this.total_page);
            // this.setPageTitle(data.data);
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },

    search() {
      console.log("keyword", this.keyword);
      this.list();
    },
    clickPage(pageNum) {
      this.send_params.offset = Utils.getNextOffset(
        pageNum,
        this.send_params.limit
      );
      this.list();
    },
    listCategories() {
      Utils.request(this, true, "blog")
        .get(`/categories/`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.categories = data.data;
          }
        })
        .catch(error => {
          Utils.showErrorMessage(this, error.response);
        });
    }
  },
  mounted() {
    this.listCategories();
    if (this.$route.params.id) {
      this.send_params.id = this.$route.params.id;
    }

    this.getPost();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blog/BlogSinglePost.vue